import card1bg from "../assets/whychooseus/card1bg.png";
import card2bg from "../assets/whychooseus/card2bg.png";
import card3bg from "../assets/whychooseus/card3bg.png";
import card4bg from "../assets/whychooseus/card4bg.png";

const WhyChooseUs = () => {
  const cards = [
    {
      title: "Instant Approval",
      desc: "Get your loan approved within minutes of submitting your application with our AI-driven system.",
      bg: card1bg,
      theme: "light"
    },
    {
      title: "Minimal Documentation",
      desc: "Complete your application digitally with minimal documentation & faster processing.",
      bg: card2bg,
      theme: "light"
    },
    {
      title: "100% Digital",
      desc: "Complete your entire loan journey online with a seamless, paperless experience.",
      bg: card3bg,
      theme: "light"
    },
    {
      title: "No Hidden Charges. Zero Collateral.",
      desc: "100% transparency throughout your loan journey.",
      bg: card4bg,
      theme: "dark"
    }
  ];

  return (
    <section className="w-full bg-[#F8FAFC] py-12 sm:py-16 md:py-20 lg:py-24 flex flex-col items-center justify-center overflow-hidden">
      <div className="max-w-[1500px] w-full px-4 sm:px-6 lg:px-20 flex flex-col items-center">

        {/* Section Header */}
        <div className="text-center flex flex-col items-center gap-3 mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-[45px] font-black text-[#0F172A] tracking-tight">
            Why <span className="text-[var(--primary)]">Choose</span> Us
          </h2>
          <p className="text-slate-500 font-medium text-sm sm:text-base lg:text-lg max-w-2xl">
            Experience a lending process designed for your convenience and peace of mind.
          </p>
        </div>

        {/* Cards grid — 2 cols on mobile/tablet, flex row on desktop */}
        <div className="grid grid-cols-2 items-start lg:flex lg:flex-row lg:items-end lg:justify-between gap-3 sm:gap-4 lg:gap-6 w-full">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className={`w-full rounded-[20px] lg:rounded-[32px] overflow-hidden flex flex-col justify-start relative text-left transition-all duration-300 ${
                idx === 1 ? 'self-end lg:self-auto' : ''
              } ${
                idx === 0 || idx === 3
                  ? 'min-h-[280px] sm:min-h-[360px] md:min-h-[420px] lg:h-[585px] lg:w-[24%]'
                  : 'min-h-[240px] sm:min-h-[270px] md:min-h-[320px] lg:h-[490px] lg:w-[24%]'
              } ${
                card.theme === 'dark' ? 'text-white' : 'text-[#0F172A]'
              }`}
            >
              {/* Background image — always visible (drives entire card visual) */}
              <div
                className="absolute inset-0 bg-cover bg-no-repeat bg-center z-0 pointer-events-none"
                style={{ backgroundImage: `url(${card.bg})` }}
              />

              {/* Content */}
              <div className="relative z-10 flex flex-col items-start gap-1 sm:gap-2 lg:gap-3 h-full p-3 sm:p-5 lg:p-8">
                <h3 className={`text-[13px] sm:text-lg lg:text-[22px] font-extrabold tracking-tight leading-snug lg:pt-4 ${
                  card.theme === 'dark' ? 'text-white' : 'text-[#0F172A]'
                }`}>
                  {card.title}
                </h3>

                <p className={`text-[10px] sm:text-[13px] lg:text-[15px] font-semibold leading-relaxed ${
                  card.theme === 'dark' ? 'text-slate-300' : 'text-slate-500'
                }`}>
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
